import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReactDOM from "react-dom";
import { Helmet } from "react-helmet";
import App from "./App";
import "./index.css";
import React from "react";
import { AppProvider } from "contexts/appProvider";
import { Provider } from "react-redux";
import store from "redux/store";

const logoPath = import.meta.env.VITE_ORG_LOGO_BROWSER || "logo_common.ico";
const orgName = import.meta.env.VITE_ORG_NAME || "loading...";
const themeColor = import.meta.env.VITE_THEME_COLOR || "#000000";
const description = import.meta.env.VITE_DESCRIPTION || "";

ReactDOM.render(
    <Provider store={store}>
        <AppProvider>
                <DndProvider backend={HTML5Backend}>
                    <>
                        <Helmet>
                            <meta charSet="utf-8" />
                            <meta name="viewport" content="initial-scale=1.0, maximum-scale=1.0" />
                            <meta name="theme-color" content={themeColor} />
                            <meta name="description" content={description} />
                            <title>{orgName}</title>
                            <link rel="icon" href={logoPath} />
                            <link rel="manifest" href="/manifest.json" />
                        </Helmet>
                        <App />
                    </>
                </DndProvider>
        </AppProvider>
    </Provider>,
    document.getElementById("root")
);